export default __webpack_public_path__ + "static/media/Restriction_FR.187e9d19.pdf";